/*
 * See the file LICENSE for the full license governing this code.
 */

import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import Delete from './Delete';

function MoreOptions({ id, 'display-name': name, deleteCluster, disabled }) {
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);

  const closeDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const confirmDelete = () => {
    deleteCluster(id);
    closeDeleteDialog();
  };

  return (
    <>
      <Delete
        name={name}
        open={openDeleteDialog}
        onClose={closeDeleteDialog}
        deleteCluster={confirmDelete}
      />
      <Tooltip title="Delete server">
        <span>
          <IconButton
            data-cy="delete-cluster"
            disabled={disabled}
            sx={{ color: 'inherit' }}
            onClick={() => {
              setOpenDeleteDialog(true);
            }}
          >
            <DeleteIcon />
          </IconButton>
        </span>
      </Tooltip>
    </>
  );
}

export default MoreOptions;
